import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full flex justify-center items-center" }
const _hoisted_2 = ["src", "alt"]

import { computed } from 'vue';
import Spinner from '../spinner/Spinner.vue';
import { useImage } from './image-controller';

interface Props {
  id: number,
  alt?: string,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Image',
  props: {
    id: null,
    alt: null
  },
  setup(__props: any) {

const props = __props as {
  id: number,
  alt?: string,
}



const {src, loading} = useImage(computed(() => props.id));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(loading))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "w-full h-full",
          src: _unref(src),
          alt: __props.alt
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createBlock(Spinner, { key: 1 }))
  ]))
}
}

})